import BeCuponUtils from "@/utils/Utils";

export default class CouponReferenceUser {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        referenceCouponUserRetrieve(id: ${id}) {
          id
          created
          user {
            id
            email
            profile {
              image {
                url
              }
            }
          }
          referenceCoupon {
            coupon {
              id
              title
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.referenceCouponUserRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query {
        referenceCouponUserList(pageSize: 1000) {
          results {
            id
            created
            user {
              id
              email
              }
              referenceCoupon {
                coupon {
                  id
                  title
                }
              }              
            }
          }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i = 0; i < response.data.data.referenceCouponUserList.results.length; i++) {
      response.data.data.referenceCouponUserList.results[i].created = BeCuponUtils.formatDateTime(response.data.data.referenceCouponUserList.results[i].created); 
    }

    return response.data.data.referenceCouponUserList.results.reverse();
  }
}